module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n     y=\"0px\" viewBox=\"0 0 4.4 6.6\">\n  <path fill=\"none\" stroke=\"#699CD3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n        d=\"M0.8,0.8l2.5,2.5L0.8,5.8\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./app/assets/images/icons/btn_arrow_short.svg
// module id = 338
// module chunks = 1